import * as React from "react";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileModel } from "../../../models/fileModel";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import * as Constants from '../../../common/constants';
import { RawDataSourceModel } from "../../../models/dataSynchronization";
import DataSyncService from '../../../services/dataSyncService';
import { RawDataFilterSettingsModel } from "../../../models/dataSynchronization";
import { RawDataSourceListModel } from "../../../models/dataSynchronization";
import { RawDataResultModel } from "../../../models/dataSynchronization";
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import { AuthorisationStatus, Lang } from '../../../common/enums';
import { RawDataStatus } from '../../../common/enums';
import { DataSourceType } from '../../../common/enums';
import { LoadDataFilter } from './loadDataFilter';
import { Toolbar } from 'primereact/toolbar';
import { FullSyncResultModel } from "../../../models/dataSynchronization";
import { EmaDataRowModel } from "../../../models/dataSynchronization";
import LoadDataAddEditDialog from './loadDataAddEditDialog';
import { EmaDataRowContentModel } from '../../../models/dataSynchronization/emaDataRowContentModel'

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  isVisibleConfirmDialog: boolean;
  validationMessage: string;
  loadMessage: string;
  selectedFile: any;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  currentDataSourceRow: RawDataSourceModel;
  loadDataResult: RawDataResultModel;
  loadedDataRows: Array<RawDataSourceModel>;
  loadDataFiterSettings: RawDataFilterSettingsModel;
  currentRawData: EmaDataRowModel;
  isVisibleAddNewDialog: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class LoadDataContainer extends React.Component<IProps, IState> {
  growl: any;
  refFile: any;
  currentFile: FileModel;
  dataSyncService = new DataSyncService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      loadMessage: '',
      isLoading: false,
      isVisibleConfirmDialog: false,
      selectedFile: null,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      currentDataSourceRow: new RawDataSourceModel(),
      loadDataResult: new RawDataResultModel(),
      loadedDataRows: new Array<RawDataSourceModel>(),
      currentRawData: new EmaDataRowModel(),
      loadDataFiterSettings: new RawDataFilterSettingsModel(),
      isVisibleAddNewDialog: false
    };
  }

  componentDidMount() {
    this.getAll(this.state.from, this.state.numberOfRows);
  }

  getAll = (from: number, numberOfRows: number) => {
    this.setState({
      isLoading: true
    });

    this.dataSyncService.getAllLoaded(from, numberOfRows, this.state.loadDataFiterSettings)
      .then(
        (data: RawDataSourceListModel) => {
          this.setState({
            isLoading: false,
            from: from,
            loadedDataRows: data.rawDataSource,
            totalRecordsCount: data.totalRecordsCount
          });
        },
        error => {
          this.setState({
            error
          });
          this.setState({
            isLoading: false
          });
        }
      );
  }

  getDataSourceRow = (id) => {
    this.setState({ isLoading: true })
    this.dataSyncService.getDataSourceRow(id)
      .then(
        (data: RawDataSourceModel) => {
          this.setcurrenDataSourceRow(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  setcurrenDataSourceRow(row: RawDataSourceModel) {
    this.setState({ currentDataSourceRow: { ...row } });
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAll(startIndex, this.state.numberOfRows);
  }

  handleDeleteClick = (id) => {
    this.getDataSourceRow(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteDataSource = (id) => {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.dataSyncService.deleteAllImportedData(id)
      .then(
        data => {
          this.getAll(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleOnChange(event) {
    let file: File = event.target.files[0];
    let message = '';
    let fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

    this.currentFile = new FileModel();

    if (!fileExtension.match(/(xlsx|csv|xml)$/i)) {
      message += 'Allowed file types are (xlsx, csv, xml)';
    }

    // if (file.size > Constants.MaxFileUploadSize) {
    //   message += 'File size is greater than ' + HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3) + '.<br />';
    // }

    this.setState({
      validationMessage: message
    });

    if (!message) {
      this.currentFile.fileName = file.name;
      this.currentFile.fileType = fileExtension;
      this.currentFile.fileSizeInBytes = file.size;

      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.currentFile.fileContent = reader.result;
        this.handleAddFile(this.currentFile);
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  handleAddFile = (fileModel: FileModel) => {
    if (fileModel) {
      this.setState({
        selectedFile: fileModel
      });
    }
  }

  handleRemoveFile = () => {
    this.setState({
      selectedFile: null
    });
  }

  handleImportFile = () => {
    if (this.state.selectedFile) {
      this.setState({
        isLoading: true
      });

      this.dataSyncService.loadDataFromFile(this.state.selectedFile)
        .then(
          (data: RawDataResultModel) => {
            this.setState({
              isLoading: false,
              loadDataResult: data
            });
            this.setImportResultMessage(data);
          },
          error => {
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    }
    else {
      let message = 'File not valid';
      this.setState({
        validationMessage: message
      });
    }
  }

  handleFullSyncClick = () => {
    if (this.state.selectedFile) {
      this.setState({
        isLoading: true
      });

      this.dataSyncService.loadImportSyncData(this.state.selectedFile)
        .then(
          (data: FullSyncResultModel) => {
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    }
    else {
      let message = 'File not valid';
      this.setState({
        validationMessage: message
      });
    }
  }

  setImportResultMessage(loadResult: RawDataResultModel) {
    let loadMessage = "<p>" + "Data loaded successefully!" + "</p>"
      + "<p>" + "All medcines in file: " + loadResult.allMedicinesInFileCount + " "
      + "| " + "Human medicines: " + loadResult.humanMedicinesCount + " "
      + "(" + "Authorised: " + loadResult.authorisedMedicinesCount
      + ", " + "Withdrawn: " + loadResult.withdrawnMedicinesCount
      + ", " + "Refused: " + loadResult.refusedMedicinesCount
      + ", " + "Suspended: " + loadResult.suspendedMedicinesCount
      + ", " + "Pending: " + loadResult.pendingMedicinesCount + ") "
      + "| " + "Veterinary medicines: " + loadResult.veterinaryMedicinesCount + " "
      + "| " + "Transactions failed: " + loadResult.transactionFailedCount + " "
      + "| " + "Exists in DB (not inserted): " + loadResult.insertedInRawDataCount + " "
      + "| " + "Exists in DB (inserted for updated): " + loadResult.insertedForUpdateCount + "</p>";

    this.setState({
      isLoading: false,
      loadMessage: loadMessage
    });

    this.getAll(this.state.from, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings: RawDataFilterSettingsModel) => {
    this.setState({
      isLoading: true
    });

    if (settings.authorisationStatusId && settings.authorisationStatusId < 1)
      settings.authorisationStatusId = undefined;

    if (settings.rawDataStatusId && settings.rawDataStatusId < 1)
      settings.rawDataStatusId = undefined;

    if (settings.dataSourceTypeId && settings.dataSourceTypeId < 1)
      settings.dataSourceTypeId = undefined;

    this.dataSyncService.getAllLoaded(initFrom, numberOfRows, settings).then(
      (data: RawDataSourceListModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          loadedDataRows: data.rawDataSource,
          totalRecordsCount: data.totalRecordsCount,
          loadDataFiterSettings: settings
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  hadleAddNewButtonClick = (show: boolean) => {
    const langKeys = HelperFunctions.getEnumKeys(Lang);
    let contentList = new Array<EmaDataRowContentModel>(0);

    langKeys.map(k => {
      let content = new EmaDataRowContentModel();
      content.langId = parseInt(Lang[k]);
      content.eparPlainText = '';
      contentList.push(content);
    });

    let newDataRow = new EmaDataRowModel();

    newDataRow.rowContent = contentList;
    this.setState({
      currentRawData: newDataRow,
      isVisibleAddNewDialog: show
    })
  };

  importSingleMedicineClick = (rawData: EmaDataRowModel) => {

  }

  showAddEditDialog = (show: boolean) => {
    this.setState({
      isVisibleAddNewDialog: show
    })
  }

  handleAddNewCancelButton = () => {
    this.showAddEditDialog(false)
    this.getAll(this.state.from, this.state.numberOfRows);
  }

  handleEditClick = (id: number) => {
    this.setState({ isLoading: true });
    this.dataSyncService.getDataSourceFull(id).then(
      (data) => {
        this.setState({
          isLoading: false,
          currentRawData: data,
          isVisibleAddNewDialog: true
        });
      },
      error => {
        this.setState({
          isLoading: false,
          error
        });
      }
    );
  }

  public render() {
    const { isLoading, error, selectedFile, loadMessage, loadedDataRows } = this.state;

    let filePlaceholderLabel = "";
    if (selectedFile) {
      filePlaceholderLabel = selectedFile.fileName + ", " + HelperFunctions.formatBytes(selectedFile.fileSizeInBytes, 3);
    } else {
      filePlaceholderLabel = "Allowed file type is EMA EPAR .xlsx file";
    }

    return (
      <>
        <div>
          {isLoading ? <Spinner /> : null}
          {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          <Growl ref={(el) => this.growl = el} />

          <Toolbar style={{ marginTop: '10px', marginBottom: '10px' }}>

            <div style={{ marginTop: "10px", marginBottom: '10px' }}>
              <h3>Load data from file</h3>
            </div>

            <div style={{ marginBottom: '10px' }}>
              <input type="file" onChange={(e) => this.handleOnChange(e)} style={{ display: 'none' }} ref={(el) => this.refFile = el} />
              <div className="p-inputgroup">
                <Button
                  icon="pi pi-plus"
                  className="p-button-info"
                  type="button"
                  label="Browse"
                  tooltip="Add new file"
                  tooltipOptions={{ position: 'top' }}
                  onClick={(e) => this.refFile.click()}
                  style={{ width: 'auto' }}
                />
                <InputText
                  style={{ width: '400px' }}
                  readOnly={true}
                  placeholder={filePlaceholderLabel} />
                <Button
                  icon="pi pi-download"
                  label="Load"
                  className="p-button-success"
                  onClick={() => this.handleImportFile()} />
                <Button
                  icon="pi pi-times"
                  label="Remove"
                  className="p-button-danger"
                  onClick={() => this.handleRemoveFile()} />
              </div>
              <div>
                <Button
                  style={{ float: 'right' }}
                  icon="pi pi-refresh"
                  label="Full Synchronization"
                  className="p-button-success"
                  onClick={() => this.handleFullSyncClick()} />
                <Button
                  style={{ marginRight: "10px", marginBottom: "5px", width: 'auto', float: 'right' }}
                  //icon="pi pi-pencil"
                  className="p-button-success"
                  type="button"
                  label="Add new"
                  tooltip="Add single medicine"
                  tooltipOptions={{ position: 'top' }}
                  onClick={() => this.hadleAddNewButtonClick(true)}
                />
              </div>
            </div>

            <div>
              {loadMessage ? <AlertMessage type='success'>{loadMessage}</AlertMessage> : null}
            </div>

          </Toolbar>

          {/* <div>
            {loadMessage ? <AlertMessage type='success'>{loadMessage}</AlertMessage> : null}
          </div> */}

          <div>
            <LoadDataFilter
              onSearchClick={this.handleSearchButtonClick}
              totalRecordsCount={this.state.totalRecordsCount}
            />
          </div>

          <div>
            <DataTable
              value={loadedDataRows}
              paginator={true}
              lazy={true}
              rows={this.state.numberOfRows}
              totalRecords={this.state.totalRecordsCount}
              onPage={(event) => this.handleOnPageClick(event)}
              first={this.state.from}
            >
              <Column
                style={{ textAlign: "center", width: "8em" }}
                field="rawDataSourceId"
                header="ID"
              />
              <Column
                field="medicineName"
                header="Medicine Name"
              />
              <Column
                field="productNumber"
                header="Product Number" />
              <Column
                field="authorisationStatusId"
                header="Authorisation Status"
                body={(rowData, column) =>
                  getEnumLabel(rowData.authorisationStatusId, AuthorisationStatus, true)
                }
              />
              <Column
                field="rawDataStatusId"
                header="Load Status"
                body={(rowData, column) =>
                  getEnumLabel(rowData.rawDataStatusId, RawDataStatus, true)
                }
              />
              <Column
                field="dataSourceTypeId"
                header="Data Source"
                body={(rowData, column) =>
                  getEnumLabel(rowData.dataSourceTypeId, DataSourceType, true)
                }
              />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      className="p-button-warning"
                      tooltip="Edit"
                      tooltipOptions={{ position: 'top' }}
                      style={{ marginRight: ".5em" }}
                      onClick={() => this.handleEditClick(rowData.rawDataSourceId)}
                    />
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      className="p-button-danger"
                      tooltip="Remove"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => this.handleDeleteClick(rowData.rawDataSourceId)}
                    />
                  </div>
                }
              />
            </DataTable>
          </div>
        </div>

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteDataSource(this.state.currentDataSourceRow.rawDataSourceId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentDataSourceRow.medicineName}"?
        </ConfirmDialog>

        {this.state.isVisibleAddNewDialog ? (
          <LoadDataAddEditDialog
            importClick={this.importSingleMedicineClick}
            cancelClick={this.handleAddNewCancelButton}
            isVisible={this.state.isVisibleAddNewDialog}
            currentRawData={this.state.currentRawData}
          />
        ) : null}
      </>
    );
  }
}

export default LoadDataContainer;